import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import SiteSelection from "./SiteSelection";
import EnterCar from "./EnterCar";
import QrCodeScanner from "./QrCodeScanner";
import Completion from "./CompletionPage";
import ViewPayment  from "./ViewPayment";
import ErrorPage from "./ErrorPage";
import Management from "./Management";
import ManagementLogin from "./ManagementLogin";
import ProtectedRoute from "./ProtectedRoute";
import Payment from "./Payment";
import PrivacyPolicy from "./PrivacyPolicy";

const App = () => {
    useEffect(() => {
        const initLandbot = () => {
            if (!window.myLandbot) {
                const s = document.createElement('script');
                s.type = "module";
                s.async = true;
                s.addEventListener('load', () => {
                    window.myLandbot = new window.Landbot.Livechat({
                        configUrl: 'https://storage.googleapis.com/landbot.online/v3/H-2820616-7RF1ZOJ8QO8F7IXZ/index.json',
                    });
                });
                s.src = 'https://cdn.landbot.io/landbot-3/landbot-3.0.0.mjs';
                const x = document.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            }
        };

        // Call the function immediately instead of waiting for an event
        initLandbot();
    }, []);

    return (
        <Routes>
            <Route path="/" element={<SiteSelection />} />
            <Route path="/enter-car" element={<EnterCar />} />
            <Route path="/view-payment" element={<ViewPayment />} />
            <Route path="/qr-scanner" element={<QrCodeScanner />} />
            <Route path="/completion" element={<Completion />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/login" element={<ManagementLogin />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
                path="/management"
                element={<ProtectedRoute element={<Management />} />}
            />
        </Routes>
    );
};

export default App;
